import { render, staticRenderFns } from "./version.vue?vue&type=template&id=79152e46&scoped=true"
import script from "./version.vue?vue&type=script&lang=js"
export * from "./version.vue?vue&type=script&lang=js"
import style0 from "./version.vue?vue&type=style&index=0&id=79152e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79152e46",
  null
  
)

export default component.exports